import Vue from 'vue';
import Router from '@app/router';
import Prefetcher from '@app/router/prefetcher';
import { EventTracking, EventType } from '@app/tracking';
import Helpers from '@app/global/helpers';
Vue.directive('parse-content', {
    inserted: function (el) {
        // Replace internal native a-link with Vue router-links
        el.addEventListener('click', function (event) { return handleLinkClicks(event); });
        // Observe internal native links for prefetching
        Array.from(el.querySelectorAll('a[href]'))
            .filter(function (a) { return !Helpers.isExternalLink(a.href); })
            .forEach(function (a) { return Prefetcher.observe(a); });
        // Scale down inline images
        var images = Array.from(el.querySelectorAll('img'));
        images.forEach(function (image) { return transformImage(image); });
    }
});
function transformImage(image) {
    image.setAttribute('loading', 'lazy');
    if (image.style.width) {
        var width = parseInt(image.style.width.replace('px', ''));
        image.src = image.src.replace('0x0', width * 2 + "x0");
    }
    else {
        image.classList.add('img-fluid', 'w-100');
        image.src = image.src.replace('0x0', '1520x0');
    }
}
function handleLinkClicks($event) {
    var target = $event.target;
    // handle only links that occur inside the component and do not reference external resources
    if (target && target.matches("a:not([href^='http'])") && target.href) {
        // some sanity checks taken from vue-router:
        // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
        var altKey = $event.altKey, ctrlKey = $event.ctrlKey, metaKey = $event.metaKey, shiftKey = $event.shiftKey, button = $event.button, defaultPrevented = $event.defaultPrevented;
        // don't handle with control keys
        if (metaKey || altKey || ctrlKey || shiftKey)
            return;
        // don't handle when preventDefault called
        if (defaultPrevented)
            return;
        // don't handle right clicks
        if (button !== undefined && button !== 0)
            return;
        // don't handle if `target="_blank"`
        if (target && target.getAttribute) {
            var linkTarget = target.getAttribute('target');
            if (/\b_blank\b/i.test(linkTarget))
                return;
        }
        var url = new URL(target.href);
        var to = url.pathname;
        // don't handle media download links
        if (to.substring(0, 7) == '/media/')
            return;
        // don't handle same page links/anchors
        if (window.location.pathname !== to && $event.preventDefault) {
            $event.preventDefault();
            Router.push(to);
        }
    }
    else if (target && target.matches("a") && target.href) {
        $event.preventDefault();
        var domain = window.location.protocol + '//' + window.location.hostname;
        if (target.href.indexOf(domain) !== -1) {
            // Internal absolute
            Router.push(target.href.replace(domain, ''));
        }
        else {
            // Real outbound link
            EventTracking.dispatch(EventType.Track, {
                category: 'Outbound',
                action: 'click',
                label: target.href
            });
            window.open(target.href, target.target || '_self');
        }
    }
}
